@if (true) {
  <klt-table-v2
    [stickyTop]="true"
    [loading]="false"
    [showTooltip]="false"
    [equalWidth]="true"
    [data]="reitTableData.data"
    [columns]="reitTableData.headers"
    [columnGroups]="reitTableData.sections"
    [filteredColumnKeys]="filteredColumns"
    [top]="isPopup ? 78 : 188"
    (cellSaveClick)="onCellSave($event)"
    (sort)="onTableSort($event)"
    >
  </klt-table-v2>
}
